<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group row">
            <div class="col-md-3">
              <label class="col-form-label">{{ $t("select-category") }}:</label>
            </div>
            <div class="col-md-8">
              <v-select
                name="categoryIds"
                multiple
                v-model="addData.categoryIds"
                label="name"
                :options="categoriesList"
                :reduce="(categoryList) => categoryList.id"
                @input="changeCategoryId"
                v-validate="'required'"
              >
                <template #option="categoryList">
                  <div class="product-label">
                    {{ categoryList.name }}
                  </div>
                </template>
              </v-select>
              <small v-show="errors.has('categoryIds')" class="text-danger">
                {{ $t("field_required") }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-4 col-sm-offset-2">
          <button class="btn btn-primary btn-sm" @click="getProducts">
            Pobierz
          </button>
        </div>
      </div>
      <div class="hr-line-dashed"></div>

      <data-tables
        v-if="showData == true"
        :url="urlProducts"
        :columns_list="columns_list"
        :addData="addData"
        @loading="setLoading"
      />
    </div>
  </div>
</template>

<script>
import DataTables from '@/components/DataTables'

export default {
  name: 'ListProducts',
  components: {
    DataTables
  },
  data() {
    return {
      showData: false,
      excel: true,
      addData: {
        categoryIds: []
      },
      categoriesList: [],
      columns_list: [
        {
          key: 'id',
          name: this.$t( 'edit' ),
          filter: 'btn',
          btn: a =>
            `<a href="#/przymierzalnia/${this.$route.params.env}/produkty/${a}"><i class="fa fa-edit"></i></a>`
        },
        {
          key: 'plum',
          name: 'Plum',
          type: 'text',
          sortable: true
        },
        {
          key: 'ean',
          name: 'EAN',
          type: 'text',
          sortable: true
        },
        {
          key: 'name_prefix',
          name: 'Prefix',
          type: 'text',
          sortable: true
        },
        {
          key: 'name',
          name: 'Nazwa',
          type: 'text',
          sortable: true
        },
        {
          key: 'name_suffix',
          name: 'Suffix',
          type: 'text',
          sortable: true
        },
        {
          key: 'image_url',
          name: 'Zdjęcie',
          filter: 'image',
          width: '100'
        },
        {
          key: 'visible',
          name: 'Widoczny',
          type: 'text',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_pl',
          name: 'Widoczny PL',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_en',
          name: 'Widoczny EN',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_de',
          name: 'Widoczny DE',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_es',
          name: 'Widoczny ES',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_it',
          name: 'Widoczny IT',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        },
        {
          key: 'visible_fr',
          name: 'Widoczny FR',
          type: 'boolean',
          filter: 'boolean',
          sortable: true
        }
      ]
    }
  },
  async created() {
    await this.getCategoriesList()
    this.$emit( 'loading', false )
  },
  computed: {
    urlProducts() {
      return `vnfr/${this.$route.params.env}/products/list`
    }
  },
  methods: {
    changeCategoryId( data ) {
      this.showData = false
      console.log( data )
      if ( data.includes( 0 ) ) {
        if ( data[ 0 ] == 0 && data.length > 1 ) {
          this.addData.categoryIds = data.filter( el => el != 0 )
        } else {
          this.addData.categoryIds = data.filter( el => el == 0 )
        }
      }
    },
    getProducts() {
      this.$validator.validateAll().then( result => {
        if ( result ) {
          this.showData = true
        }
      } )
    },
    setLoading( boolean ) {
      this.$emit( 'loading', boolean )
    },
    getCategoriesList() {
      return this.$http
        .get( `vnfr/${this.$route.params.env}/categories/select-list` )
        .then( resp => {
          const categories = resp.data.data
          categories[ 0 ].name = 'Brak kategorii'
          this.categoriesList = categories
        } )
        .catch( err => {
          this.$toastr.error( err )
          return false
        } )
    }
  }
}
</script>
